import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import SearchResultItem from '../SearchResultItem';

const SuggestedItem = ({ item, displayIndex, selectedIndex, onSelect, onHoverItem }) => {
  const handleMouseEnter = useCallback(
    () => onHoverItem(displayIndex),
    [onHoverItem, displayIndex],
  );

  return (
    <SearchResultItem
      isSelected={displayIndex === selectedIndex}
      item={item}
      onClick={onSelect}
      onMouseEnter={handleMouseEnter}
    />
  );
};

SuggestedItem.propTypes = {
  displayIndex: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onHoverItem: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SuggestedItem;
